import appColors from 'utils/appColors';
const { makeStyles } = require('@material-ui/core');

const useStyles = makeStyles(() => ({
  headerContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 4,
    paddingBottom: 8,
    paddingTop: 4,
    marginLeft: 16,
    minHeight: 48,
    backgroundColor: appColors.BACKGROUND_COLOR,
  },
  header_min: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 4,
    paddingBottom: 8,
    paddingTop: 4,
    minHeight: 48,
    backgroundColor: appColors.BACKGROUND_COLOR,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flex: '1 1 auto',
    marginRight: 12,
  },
  titleStyle: {
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: 1.25,
    marginLeft: 8,
    color: appColors.GRAY_TEXT_COLOR,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
